<template>
  <div class="report-parameters">
    <h3 class="title">Report Parameters</h3>

    <div class="params-grid">
      <!-- Row 1 -->
      <ParameterItem label="Brand" :value="request.brandCode" />
      <ParameterItem label="Report Type" :value="mapReportType(request.reportPeriodType)" />
      <ParameterItem label="Month / Year" :value="formatMonthYear(request.focusMonth, request.focusYear)" />
      <ParameterItem label="Price Type" :value="mapPriceType(request.priceType)" />

      <!-- Row 2 -->
      <ParameterItem label="Member Type" :value="joinArray(request.memberTypes)" />
      <ParameterItem label="Include V" :value="request.includeV ? 'Yes' : 'No'" />

      <!-- Row 3 -->
      <ParameterItem
          class="start-row"
          label="Stores"
          :value="joinArray(request.stores)"
      />

      <ParameterItem
          class="span-2"
          label="Product Category 1"
          :value="joinArray(request.categoryLevel1)"
      />

      <!-- Row 4 -->
      <ParameterItem
          class="span-2"
          label="Product Category 2"
          :value="joinArray(request.categoryLevel2)"
      />
      <ParameterItem
          class="span-2"
          label="Product Category 3"
          :value="joinArray(request.categoryLevel3)"
      />

      <!-- Row 5  -->
      <ParameterItem
          class="span-2"
          label="Product Category 4"
          :value="joinArray(request.categoryLevel4)"
      />
      <ParameterItem
          class="span-2"
          label="Product Category 5"
          :value="joinArray(request.categoryLevel5)"
      />
    </div>
  </div>
</template>

<script>
export default {
  name: "ReportParameters",

  props: {
    request: {
      type: Object,
      required: true,
    },
  },

  components: {
    ParameterItem: {
      props: {
        label: String,
        value: String,
      },
      template: `
        <div class="item">
          <div class="label">{{ label }}</div>
          <div class="value">{{ value || '-' }}</div>
        </div>
      `,
    },
  },

  methods: {
    joinArray(value) {
      if (!value || value.length === 0) return "-";

      if (Array.isArray(value)) {
        return value.join(", ");
      }

      return value;
    },

    formatMonthYear(month, year) {
      if (!month || !year) return "-";
      const date = new Date(year, month - 1);
      return date.toLocaleString("en-US", {
        month: "long",
        year: "numeric",
      });
    },

    mapReportType(type) {
      const map = {
        MTD: "MTD",
        YTD: "YTD",
        RTD: "RTD",
      };
      return map[type] || type || "-";
    },

    mapPriceType(type) {
      const map = {
        NET: "Net Price",
        GROSS: "Gross Price",
      };
      return map[type] || type || "-";
    },
  },
};
</script>

<style scoped>
.report-parameters {
  background: #ffffff;
  border-radius: 12px;
  padding: 24px 32px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
}

::v-deep .title {
  font-size: 18px;
  font-weight: 600;
  color: #000;
  margin-bottom: 20px;
}

.params-grid {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 24px 32px;
  align-items: stretch;
  grid-auto-rows: auto;
}

.params-grid > * {
  min-width: 0;
  max-width: 100%;
}

.start-row {
  grid-column: 1 / span 2;
}

.span-2 {
  grid-column: span 2;
}

::v-deep .label {
  font-size: 13px;
  color: #656c73;
  margin-bottom: 4px;
}

::v-deep .value{
  font-size: 15px;
  font-weight: 400;
  color: #000;
  max-width: 100%;

  white-space: normal;
  word-break: break-word;
  overflow-wrap: break-word;
}

@media (max-width: 1200px) {
  .params-grid {
    grid-template-columns: repeat(2, 1fr);
  }

  .span-2 {
    grid-column: span 2;
  }
}

@media (max-width: 768px) {
  .params-grid {
    grid-template-columns: 1fr;
  }

  .span-2 {
    grid-column: span 1;
  }
}
</style>